
import { MeprismEntitlement } from '../authentication/authenticationTypes'
import { DateString } from '../apiTypes'

export type MpProduct = {
  currency: string
  description: string
  id: string
  name: string
  price_cents: number
  price_id: string
  sku: string
}


export type MpProductMap = { [key: string]: MpProduct }
export type MpProductResponse = MpProduct[]

export type CheckoutSessionRequest = {
  sku: string
  ext_price_id: string
  success_url: string
  cancel_url: string
  promo_code?: string
  tracking_metadata?: Record<string, any>
}

export type UpgradeCheckoutSessionRequest = {
  current_sku: string
  upgrade_sku: string
  new_price_id: string
  return_url: string
}

export type DowngradeRequest = {
  current_sku: string
  downgrade_sku: string
  new_price_id: string
}

export type CheckoutSessionResponse = {
  muid: string
  session_id: string
  status: string
  payment_status: string
  url: string
  customer: string | null
  invoice: string | null
  subscription: string | null
  payment_intent: string | null
}

export type PortalSessionResponse = {
  url: string
  session_id: string
}

export type SubscriptionScheduleResponse = {
  has_schedule: boolean
  schedule: UserStripeSchedule | null
}

type SubscriptionScheduleType = 'upgarde' | 'downgrade' | 'cancel'

export type UserStripeSchedule = {
  schedule_type: SubscriptionScheduleType
  subscription_type: string
  schedule_start_time: string
}

export type EntitlementResponse = {
  meprism_claims: string[]
}

export type ProductSlice = {
  mpProducts: MpProductMap
  isLoading: boolean
  grant: {
    grants: Grant[]
    latest_expiration?: DateString
  }
  familyPlan: FamilyPlan
  offer?: OfferResponse
  subscriptionSchedule: SubscriptionScheduleResponse
}

type CodeType = 'corporate' | 'stripe' | 'unknown'

export type OfferResponse = {
  code: string
  description: string
  expiry_date?: DateString
  code_type: CodeType
  visible_subscription_tiers?: string[]
}

export type CodeStatusResponse = {
  code: string
  code_type: CodeType
  is_valid: boolean
  error?: string
  products: MpProduct[]
}

type GrantSource =
  | 'subscription_grant'
  | 'support_grant'
  | 'corporate_grant'
  | 'family_grant'

export type PaymentInterval = 'monthly' | 'yearly'

export type PaymentPlatform = 'n/a' | 'ios' | 'android' | 'stripe'

export type PlatformStatus =
  | 'active'
  | 'grace_period'
  | 'retry_period'
  | 'paused'
  | 'expired'
  | 'incomplete_expired'
  | 'trialing'
  | 'past_due'
  | 'canceled'
  | 'unpaid'

export type SubscriptionStatus =
  | 'active'
  | 'expired'
  | 'grace_period_expired'
  | 'cancelled'
  | 'paused'
  | 'refunded'
  | 'replaced'
  | 'incomplete'

export type BrokerConfigGroup =
  | 'all_brokers'
  | 'standard_limited_coverage_brokers'
  | 'custom_brokers'

export type Grant = {
  // TODO: enumerate grant source
  grant_source: GrantSource
  redeemed?: boolean // to handle existing users who have already redeemed a grant and dont have redeemed field
  grant_expiration: DateString
  grant_purchase_date: DateString
  sku: string
  title: string
  payment_platform: PaymentPlatform
  platform_status: PlatformStatus
  subscription_status: SubscriptionStatus
  active: boolean
  is_executive: boolean
  broker_config_group?: BrokerConfigGroup | null
}

export type GrantResponse = {
  grants: Grant[]
  latest_expiration?: DateString
  entitlements: MeprismEntitlement[]
  payment_platform: PaymentPlatform
}

export type ReceiptContext = 'refresh' | 'purchase' | 'restore'



export type FamilyResponse = {
  active: boolean
  muid?: string
  email: string
  invite_status: Invite_status
  invite_time?: DateString
}

export type FamilyPlan = {
  active: boolean
  muid?: string
  email: string
  invite_status: Invite_status
  invite_time?: DateString
  error?: string
}

type Invite_status =
  | 'queued'
  | 'invited'
  | 'accepted'
  | 'expired'
  | 'failed'
  | 'deleted'
  | ''

export type SubscriptionType =
  'Free' |
  'Core-Individual-Yearly' |
  'Core-Family-Yearly' |
  'Premium-Individual-Yearly' |
  'Premium-Family-Yearly' |
  'Ultimate-Individual-Yearly' |
  'Ultimate-Family-Yearly'

export const LEGACY_USERS_ULTIMATE_SKUS = [
  "mp.privacy.pro.t0.p0.month",
  "mp.privacy.pro.t0.p0.year",
  "mp.pro.fam.p0.year",
  "mp.pro.t0.p0.month",
  "mp.pro.fam.p0.month",
  "mp.pro.t0.p0.year"
]
